import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Indicator',
  props: {
  active: Boolean
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-2 h-2 rounded-full bg-white cursor-pointer", { 'bg-opacity-50': __props.active, 'bg-opacity-10': !__props.active }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, null, 2))
}
}

})